module.exports = __webpack_public_path__ + "static/img/shi4_2.613a517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi4_2.png
// module id = 8VyE
// module chunks = 1